export default __webpack_public_path__ + "static/media/img-05-nfts.555c54d8.png";